// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { DataTableCssOverrides } from "@keller/MobiusOverrides/DataTable";
import { xBaseTheme } from "@keller/XDL/types";
import { color, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

const stickyMode = () => css`
    ${xScreen("lte", "sm")} {
        position: sticky;
        left: -5px;
        z-index: 2;
        background-clip: padding-box;
        background: inherit;
    }
`;

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            wrapper: css`
                box-shadow: ${getProp("theme.shadows.4")};
            `,
            cell: css`
                padding: 8px 16px;
                height: 48px;
                border-bottom: 0;
                &:first-child {
                    ${stickyMode()}
                }
            `,
            head: css`
                background: ${color("common.ui5")};

                th:first-child {
                    ${stickyMode()}
                }
            `,
            header: css`
                background: ${color("common.ui5")};
                box-shadow: ${getProp("theme.shadows.4")};
                padding: 8px 16px;
                height: 40px;
            `,
            row: css`
                background: ${color("common.ui12")};
            `,
            evenRow: css`
                background: ${color("common.white")};
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 15,
            weight: "bold",
            color: "text.main",
        },
        cellTypographyProps: {
            mergeCss: true,
            size: 15,
            css: css`
                letter-spacing: 0;
                line-height: 24px;
            `,
        },
    },
} as xBaseTheme["dataTable"];
